import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';
import { logToServer } from '../utils/logger';
import { getTranslations, isLocale } from '../i18n/locales';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('React ErrorBoundary caught:', error, info.componentStack);
    logToServer({
      level: 'error',
      message: `ErrorBoundary: ${error.message}`,
      stack: error.stack,
      extra: { componentStack: info.componentStack?.slice(0, 1000) },
    });
  }

  render() {
    if (this.state.hasError) {
      const savedLocale = typeof window !== 'undefined' ? window.localStorage.getItem('sudoku_lang') : null;
      const t = getTranslations(savedLocale && isLocale(savedLocale) ? savedLocale : 'tr');
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 24,
          color: '#E7E5E4',
          textAlign: 'center',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}>
          <h2 style={{ marginBottom: 12 }}>{t.common.error}</h2>
          <p style={{ color: '#A8A29E', marginBottom: 16, maxWidth: 400 }}>
            {this.state.error?.message || t.common.error}
          </p>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              padding: '10px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#68B89F',
              color: '#1C1917',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t.common.home}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
